import { useTranslation } from 'react-i18next';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import IUpdateConfirmationModalProps from '../../interfaces/IUpdateConfirmationModalProps';

function UpdateConfirmationModal({
    title,
    content,
    opened,
    closeModal,
    closeModalCallback,
}: Readonly<IUpdateConfirmationModalProps>) {
    const { t } = useTranslation();

    return (
        <ClbModal
            title={title}
            open={opened}
            type="default"
            description={t(content)}
            onClose={() => closeModal()}
            data-testid="update-confirmation-modal"
            itemsFooter={[
                {
                    key: 'update-confirmation-approve-button',
                    id: 'update-confirmation-approve-button',
                    label: t('Update'),
                    title: t('Update'),
                    'data-testid': 'modal-approve-button',
                    onClick: () => closeModalCallback(),
                    role: 'button',
                    size: 'md',
                },
                {
                    key: 'update-confirmation-cancel-button',
                    id: 'update-confirmation-cancel-button',
                    label: t('Cancelar'),
                    title: t('Cancelar'),
                    'data-testid': 'modal-cancel-button',
                    onClick: () => closeModal(),
                    role: 'button',
                    size: 'md',
                    styleType: 'secondary',
                },
            ]}
        />
    );
}

export default UpdateConfirmationModal;
